import portfolioImage1 from '../Assert/5.png';
import portfolioImage2 from '../Assert/6.png';
import portfolioImage3 from '../Assert/7.png';
import useDocumentTitle from '../hooks/useDocumentTitle';

function Portfolio() {
  useDocumentTitle('Portfolio — MMI');

  return (
    <main className="portfolio-page">
      {/* Hero Section - No MMI Badge */}
      <section className="portfolio-hero">
        <div className="container">
          <h1 className="hero-title">
            We <span className="gradient-text">Ship.</span>
            <br />
            Large in dark.
          </h1>
          <p className="hero-description">
            Real systems. Real clients. Built by a team that's been doing this longer than most.
          </p>
        </div>
      </section>

      {/* Project 1 - Artificial Intelligence */}
      <section className="project-section">
        <div className="container">
          <div className="project-card image-right">
            <div className="project-content">
              <div className="project-category">ARTIFICIAL INTELLIGENCE</div>
              <h2 className="project-title">AI Customer Assistant</h2>
              <p className="project-description">
                A neural-driven conversational agent processing 10k+ requests hourly with 98.4% accuracy
              </p>
              <div className="project-tech">
                <span className="tech-tag">OpenAI</span>
                <span className="tech-tag">LangChain</span>
                <span className="tech-tag">React</span>
                <span className="tech-tag">Pinecone</span>
              </div>
            </div>
            <div className="project-media">
              <div className="project-image-container">
                <img 
                  src={portfolioImage1} 
                  alt="AI Customer Assistant" 
                  className="project-image"
                />
                <div className="project-image-glow"></div>
              </div>
            </div>
          </div>
          <div className="divider-line"></div>
        </div>
      </section>

      {/* Project 2 - Immersive Reality */}
      <section className="project-section">
        <div className="container">
          <div className="project-card image-left">
            <div className="project-content">
              <div className="project-category">IMMERSIVE REALITY</div>
              <h2 className="project-title">VR Training Platform</h2>
              <p className="project-description">
                Simulating high-risk technical environments for aerospace engineers in photorealistic 8K resolution.
              </p>
              <div className="project-tech">
                <span className="tech-tag">Unity</span>
                <span className="tech-tag">Meta Quest</span>
                <span className="tech-tag">Blender</span>
              </div>
            </div>
            <div className="project-media">
              <div className="project-image-container">
                <img 
                  src={portfolioImage2} 
                  alt="VR Training Platform" 
                  className="project-image"
                />
                <div className="project-image-glow"></div>
              </div>
            </div>
          </div>
          <div className="divider-line"></div>
        </div>
      </section>

      {/* Project 3 - Swarm Intelligence */}
      <section className="project-section">
        <div className="container">
          <div className="project-card image-right">
            <div className="project-content">
              <div className="project-category">SWARM INTELLIGENCE</div>
              <h2 className="project-title">Multi-Agent Workflow System</h2>
              <p className="project-description">
                Orchestrating autonomous agents to automate complex multi-departmental supply chain logistics.
              </p>
              <div className="project-tech">
                <span className="tech-tag">Python</span>
                <span className="tech-tag">FastAPI</span>
                <span className="tech-tag">OpenAI</span>
              </div>
            </div>
            <div className="project-media">
              <div className="project-image-container">
                <img 
                  src={portfolioImage3} 
                  alt="Multi-Agent Workflow System" 
                  className="project-image"
                />
                <div className="project-image-glow"></div>
              </div>
            </div>
          </div>
          <div className="divider-line"></div>
        </div>
      </section>

      {/* Project 4 - Legacy Game Dev (early MMI work) */}
      <section className="project-section">
        <div className="container">
          <div className="project-card image-left">
            <div className="project-content">
              <div className="project-number">04</div>
              <div className="project-category">LEGACY / EARLY MMI</div>
              <h2 className="project-title">Legacy Game Dev</h2>
              <p className="project-subtitle">3D Character &amp; Environment Work</p>
              <p className="project-description">
                Before agentic AI, before the silence — MMI built immersive 3D worlds,
                character animations, and game environments. This is where it started.
              </p>
              <div className="project-tech">
                <span className="tech-tag">Unity</span>
                <span className="tech-tag">Blender</span>
                <span className="tech-tag">3D Modeling</span>
                <span className="tech-tag">Game Development</span>
              </div>
            </div>
            <div className="project-media">
              <div className="project-image-container project-image-container--video">
                <video
                  className="project-video"
                  autoPlay
                  muted
                  loop
                  playsInline
                  aria-label="Legacy MMI game development — 3D character running through an environment"
                >
                  <source src="/videos/legacy-game-dev.mp4" type="video/mp4" />
                </video>
                <div className="project-video-overlay" aria-hidden="true" />
                <div className="project-image-glow"></div>
              </div>
            </div>
          </div>
          <div className="divider-line"></div>
        </div>
      </section>

      {/* More Work Coming Section */}
      <section className="more-work-section">
        <div className="container">
          <div className="more-work-content">
            <p className="more-work-text">More work coming. Humble but confident.</p>
          </div>
        </div>
      </section>

      
    </main>
  );
}

export default Portfolio;
